<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-任务-修改
    -->
  <el-dialog
    title="修改任务"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >
    <div class="product-add pb50">
      <el-form
        size="small"
        :model="form"
        ref="form"
        :rules="rules"
        label-width="100px"
      >
        <div class="common-form">修改任务</div>
        <!-- 全分类选择 -->
        <!-- <el-form-item label="选择全分类" prop="name" >
            <div>{{ form.categorya.name }}</div>
        
          <el-button @click="chooseCategory" icon="el-icon-plus">选择全分类作为任务标题</el-button>
        </el-form-item> -->

        <el-form-item label="任务名称" prop="name"
          ><el-input
            v-model="form.name"
            placeholder="请输入任务名称"
            class="max-w460"
          ></el-input
        ></el-form-item>

        <!-- 新增：任务类型选择 -->
        <el-form-item label="任务类型" prop="type">
          <el-radio-group v-model="form.type" @change="typeChange">
            <el-radio :label="1">签到任务</el-radio>
            <el-radio :label="2">福利任务</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="logo图片：" prop="model.image">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.image">
              <transition-group>
                <div v-for="(item, index) in form.image" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path" />
                    <a
                      href="javascript:void(0);"
                      class="delete-btn"
                      @click.stop="deleteImg(index, 'album')"
                      ><i class="el-icon-close"></i
                    ></a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('album')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>

        <!-- 新增：高级设置区域 -->
        <div class="advanced-settings">
          <div class="setting-title">
            <el-divider content-position="left"
              ><i class="el-icon-setting"></i> 高级设置</el-divider
            >
          </div>

          <!-- 签到任务高级设置 -->
          <template v-if="form.type === 1">
            <el-form-item label="看视频数量" prop="watch_vidoes">
              <el-input-number
                v-model="form.watch_vidoes"
                :min="0"
                :max="10"
                controls-position="right"
                placeholder="请输入需要观看的视频数量"
              ></el-input-number>
              <div class="tip-text">设置每日需要观看的视频数量</div>
            </el-form-item>

            <el-form-item label="提示信息" prop="tip">
              <el-input
                v-model="form.tip"
                placeholder="请输入提示信息"
                class="max-w460"
              >
              </el-input>
              <div class="tip-text">显示给用户的提示说明文字</div>
            </el-form-item>
          </template>

          <!-- 福利任务高级设置 -->
          <template v-else-if="form.type === 2">
              <el-form-item label="触发方式" prop="trigger_type">
      <el-radio-group v-model="form.trigger_type" @change="handleTriggerChange">
        <el-radio label="link">跳转链接</el-radio>
        <el-radio label="shake">摇一摇</el-radio>
        <el-radio label="share">分享</el-radio>
      </el-radio-group>


        <!-- <el-form-item label="背景图片：" prop="model.bannar" v-if="form.trigger_type == 'link'">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.bannar">
              <transition-group>
                <div v-for="(item, index) in form.bannar" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path" />
                    <a
                      href="javascript:void(0);"
                      class="delete-btn"
                      @click.stop="deleteImg(index, 'bannar')"
                      ><i class="el-icon-close"></i
                    ></a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('bannar')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item> -->
      
        <template v-if="form.trigger_type == 'link'">
            <el-form-item label="红包雨持续时间" prop="watch_vidoes">
              <el-input-number
                v-model="form.time"
                :min="10"
                controls-position="right"
                placeholder="请输入红包雨持续多少秒"
              ></el-input-number>
            </el-form-item>
             <div class="tip-text">最小值为10s</div>
        </template>
      <!-- 跳转链接输入框（仅当选择跳转链接时显示） -->
      <el-input
        v-if="form.trigger_type === 'link'"
        v-model="form.link_url"
        placeholder="请输入跳转链接地址"
        class="max-w460"
        style="margin-top: 10px;"
      >
        <el-button
          slot="append"
          icon="el-icon-link"
          @click="openLinkDialog"
        >选择链接</el-button>
      </el-input>
    </el-form-item>
            <el-form-item label="分享好友数量" prop="share_friends">
              <el-input-number
                v-model="form.share_friends"
                :min="0"
                :max="100"
                controls-position="right"
                placeholder="请输入需要分享的好友数量"
              ></el-input-number>
              <div class="tip-text">设置每日需要分享的好友数量</div>
            </el-form-item>

            <el-form-item label="获得金币" prop="max_price">
              <el-input
                v-model.number="form.max_price"
                placeholder="请输入可获得金币"
                class="max-w200"
                type="number"
                :max="2000000"
                @input="limitMaxPrice"
              >
                <template slot="append"
                  >元</template
                >
              </el-input>
              <div class="tip-text">设置用户可获得的金币（最大 2000000）</div>
            </el-form-item>
          </template>
        </div>

        <el-form-item label="任务描述">
          <div class="edit_container">
            <Uediter
              v-model="form.intro"
              :text="ueditor.text"
              :config="ueditor.config"
              ref="ue"
            ></Uediter>
          </div>
        </el-form-item>

        <el-form-item label="排序" prop="name"
          ><el-input
            v-model="form.sort"
            placeholder="请输入排序"
            class="max-w460"
          ></el-input
        ></el-form-item>

        <!--提交-->
        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc"
            >取消</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="onSubmit"
            :loading="loading"
            >提交</el-button
          >
        </div>
      </el-form>
      <Upload
        v-if="isProductUpload"
        :config="{ total: 1 }"
        :isupload="isProductUpload"
        @returnImgs="returnProductImgsFunc"
        >上传图片
      </Upload>
        <Setlink
      v-if="is_linkset"
      :is_linkset="is_linkset"
      @closeDialog="closeLinkset"
      >选择链接</Setlink
    >
      <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
    </div>
  </el-dialog>
</template>

<script>
import GtaskApi from "@/api/gtask.js";
import Upload from "@/components/file/Upload";
import Setlink from "@/components/setlink/Setlink";
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from "@/components/UE.vue";
export default {
  components: {
    /*图片上传*/
    Upload: Upload,
    Categoryas,
    draggable,
    Setlink,
    Uediter
  },
  data() {
    return {
      /*是否上传图片*/
      isupload: false,
      isImg: false,
      /*富文本配置*/
      ueditor: {
        text: "",
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        name: "",
        // 新增任务类型字段，默认为签到任务
        type: "",
        // 签到任务特有字段
        watch_vidoes: "",
           trigger_type: 'link', // 默认跳转链接
        link_url: '' ,// 跳转链接地址
        tip: "",
        image: [],
        bannar:[],
        time:60,
        image_id:0,
        // 福利任务特有字段
        share_friends: "",
        max_price: "",
        sort: 50,
        intro: ""
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: "请输入任务名称", trigger: "blur" }]
      },
      dialogVisible: false,
      iscategorya: false,
      excludeIds: [],
      isProductUpload: false,
      code: "album",
       is_linkset: false, // 控制链接选择弹窗显示
    linkDialogVisible: false, // 新增链接弹窗控制
    };
  },
  created() {
    console.log(11111);
    this.dialogVisible = this.open_add;
    this.getDetail();
  },
  props: ["open_add", "gtask_id"],
  methods: {
    limitMaxPrice() {
      if (this.form.max_price > 2000000) {
        this.form.max_price = 2000000;
      } else if (this.form.max_price < 0) {
        this.form.max_price = 0;
      }
    },
    openLinkDialog() {
    this.is_linkset = true;
  },
  
  // 关闭链接选择弹窗并处理选择结果
  closeLinkset(e) {
    this.is_linkset = false;
    if (e) {
      this.form.link_url = e.url;
      this.form.link_name = "链接到" + " " + e.type + " " + e.name;
    }
  },
  
  // 触发方式变更处理
  handleTriggerChange(val) {
    if (val !== 'link') {
      this.form.link_url = '';
      this.form.link_name = '';
    }
  },
    /* 任务类型变更处理 */
    typeChange(val) {
      this.showAdvancedSettings = true;
      // 可以在这里根据类型重置相关字段
      if (val === 1) {
        this.form.share_friends = 0;
        this.form.max_price = 0;
      } else {
        this.form.watch_vidoes = 0;
        this.form.tip = "";
      }
    },

    
    handleLinkSelect(link) {
      this.form.link_url = link.url;
      this.linkDialogVisible = false;
    },
    chooseCategory() {
      this.iscategorya = true;
    },
    /*上传*/
    openUpload(e) {
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
        this.form.image = e[0].file_path;
        this.isImg = true;
      }
      this.isupload = false;
    },
    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc() {
      //取消
      this.dialogFormVisible("error");
    },
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      GtaskApi.detail({ gtask_id: self.gtask_id }, true)
        .then(res => {
          self.form = res.data;
          self.ueditor.text = self.form.intro;
          self.isImg = true;
          self.loading = false;
          if (!self.form.bannar) {
            self.form.bannar = [];
          }
          if (!self.form.image) {
            self.form.image = [];
          }
        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      let form = self.form;
      // if(!form.categorya.categorya_id){
      //   self.$message({
      //           message:"请选择全分类",
      //           type: 'error'
      //         });
      //         return;
      // }
      if (form.image.length <= 0) {
        self.$message({
          message: "请上传图片",
          type: "error"
        });
        return;
      }
      form.gtask_id = self.gtask_id;
      form.intro = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          GtaskApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: "success"
              });
              self.dialogFormVisible("error");
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false, type: "" });
    },
    openProductUpload: function(code) {
      this.isProductUpload = true;
      this.code = code;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (this.code == "album") {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach(element => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach(e => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.image.concat(e);
          this.$set(this.form, "image", imgs);
        }
      } else {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach(element => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach(e => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.bannar.concat(e);
          this.$set(this.form, "bannar", imgs);
        }
      }

      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index, code) {
      if (code == "album") {
        this.form.image.splice(index, 1);
      } else if (code == "bannar") {
        this.form.bannar.splice(index, 1);
      }
    }
  }
};
</script>

<style>
.edit_container {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/gtask/index/part/edit.vue